import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';

import axios from "axios"
import { useEffect, useState } from "react";

const ViewStock = () => {

    const [data, setData] = useState({
        clientName: "",
        address: "",
        netWeight: ""
    })

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
        //console.log(data)
    }

    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [productName, setProductName] = useState(null);
    const [quantity, setQuantity] = useState(null);
    const [salesQuantity, setSalesQuantity] = useState(null);
    


    // Fetch user first names when the component mounts
    useEffect(() => {

        fetch('https://react-apis.dotlocalhost.com/viewstocksale.php')
            .then(response => response.json())
            .then(data => setUsers(data))
            .catch(error => console.error('Error fetching users:', error));

        fetch('https://react-apis.dotlocalhost.com/viewstock.php')
            .then(response => response.json())
            .then(data => setUsers(data))
            .catch(error => console.error('Error fetching users:', error));

    }, []);

    // Fetch the last name of the selected user
    const handleUserChange = (event) => {
        const ProName = event.target.value;
        setSelectedUser(ProName);
        setProductName(0);
        setQuantity(0);
        setSalesQuantity(0);

        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/viewstock.php?purchage_Id=${ProName}`)
                .then(response => response.json())
                .then(data => setProductName(data.productName) | setQuantity(data.quantity) )
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setProductName(null);
            setQuantity(null);
        }

        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/viewstocksale.php?purchage_Id=${ProName}`)
                .then(response => response.json())
                .then(data => setSalesQuantity(data.totalSalesQuantity) )
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setSalesQuantity(null);
        }
    };


    

    // Calculate Stock Items

    const [totalStock, setTotalStock] = useState(0);

    useEffect(() => {
        const calculateTotalQuantity = () => {
        const total = quantity - salesQuantity;
        setTotalStock(total);
        };
        calculateTotalQuantity();
    }, [quantity, salesQuantity]);

    // Calculate Stock Items

    return(
        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Current Stock</h3>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-3'>
                            <label for="" class="form-label">Purchage Id</label>
                            <select value={selectedUser} className='form-control' name="productName" onChange={handleUserChange}>
                                <option value="">Select Purchage Id</option>
                                {users.map(data => (
                                    <option key={data.purchage_Id} value={data.purchage_Id}>{data.purchage_Id}</option>
                                ))}
                            </select>
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Product Name</label>
                            <input type="text" readOnly="true" name="productName" className='form-control' onChange={handleChange} value={productName}/>
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Purchase Quantity</label>
                            <input type="text" readOnly="true" name="quantity" className='form-control' onChange={handleChange} value={quantity}/>
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Sale Quantity</label>
                            <input type="text" readOnly="true" name="salesQuantity" className='form-control' onChange={handleChange} value={salesQuantity}/>
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Current Stock</label>
                            <input type="text" readOnly="true" name="setTotalStock" className='form-control' onChange={handleChange} value={totalStock}/>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default ViewStock;